<app-television-details-display [product]="this.television"></app-television-details-display>
